module.exports = __webpack_public_path__ + "static/media/link_extension.7cf0895e.webp";